
  import { defineComponent, PropType, } from "vue";
  import {OrderEmployeeAssignment} from "@/model/OrderEmployeeAssignment";

  export default defineComponent({
    name: "OrderDetailsTabAssignmentList",
    props: {
      title: {
        type: String,
        default: ""
      },
      items: {
        type: Array as PropType<Array<OrderEmployeeAssignment>>,
        default: () => []
      },
      hasTeamLeader: {
        type: Boolean,
        default: false
      },
      showDelete: {
        type: Boolean,
        default: false
      }
    },
    setup(props, context) {
      const assignTeamLeader = (item: OrderEmployeeAssignment) => {
        context.emit("assignTeamLeader", item);
      };

      const getTeamLeaderColor = (item: OrderEmployeeAssignment) => {
        return item.teamLeader ? "primary" : "disabled";
      };

      const getTeamLeaderClass = (item: OrderEmployeeAssignment) => {
        if (props.hasTeamLeader && !item.teamLeader) {
          return "btn-not-teamleader";
        }
      };

      const deleteAssignment = (item : OrderEmployeeAssignment) => {
        context.emit("deleteAssignment", item);
      };

      return {
        assignTeamLeader,
        getTeamLeaderColor,
        getTeamLeaderClass,
        deleteAssignment
      };
    }
  });
